window.addEventListener('DOMContentLoaded', () => {
    observeDom();
    handleBulkButtonsClick()
    adjustQuantity();
    getDelivery();
    setTimeout(() => wrapNutritionTable(), 500);

    //
    document.addEventListener('click', event => {
        if (event.target.closest('.upez-product-volume-upsell fieldset.builder-block')) {
            const elUpsellFieldsets = document.querySelectorAll('.upez-product-volume-upsell fieldset.builder-block');

            [...elUpsellFieldsets].forEach(elFieldset => {
                elFieldset.classList.remove('selected');
            });

            event.target.closest('.upez-product-volume-upsell fieldset.builder-block').classList.add('selected');
            triggerCustomEvent('.quantity');
        }
    });
});

function init() {
    const query = window.location.search;
    const urlParams = new URLSearchParams(query);

    if (urlParams.has('selling_plan')) {
        triggerCustomEvent('.bsub-widget__plans-container');
    } else {
        triggerCustomEvent('.quantity');
    }
}

function observeDom() {
    const prodContainer = document.querySelector('.product__info-container');

    const observer = new MutationObserver((mutationList) =>  {
        for (const mutation of mutationList) {

            if (mutation.target === document.querySelector('.ruk_rating_snippet')) {
                checkRatingScript();
                createReviewClick();
            }

            if (mutation.target === document.querySelector('.builder-hydrated')) {
                observer.disconnect();

                observer.observe(document.querySelector('.builder-hydrated'), {
                    attributes: true, 
                    childList: true,
                    subtree: true
                });
            }

            if (mutation.target === document.querySelector('.builder-loaded')) {
                setDiscounts();
            }
            
            if (mutation.target === document.querySelector('.builder-component')) {
                multiDiscountLogic();
                observer.disconnect();
            }
        }
    });

    observer.observe(prodContainer, {
        attributes: true, 
        childList: true,
        subtree: true,
    });
}

function multiDiscountLogic() {
    const elements = document.querySelectorAll('.css-u91va4');

    if (!elements) return;

    elements.forEach(element => {
        element.addEventListener('click', () => {
            elements.forEach(element => {
                if (element.classList.contains('selected')) {
                    element.classList.remove('selected');
                }
            });

            element.classList.add('selected');

            const selector = document.querySelector('.quantity');

            if (selector) {
                const event = new Event('change');
                selector.dispatchEvent(event);
            }
        });

        const textElements = element.querySelectorAll('.builder-text');

        if (!textElements) return;

        const typeOfBottle = checkIfBottleOrSlim();
        const numOfBottles = parseInt(getNumberOfCans());

        textElements.forEach(element => {
            if (element.innerText.includes('Cases')) {
                if (element.querySelector('.custom-text')) return;

                if (typeOfBottle && numOfBottles) {
                    const numOfCases = parseInt(element.innerHTML.replace(/[^0-9]/g, ''), 10);
                    const numToDisplay = numOfBottles * numOfCases;

                    if (numToDisplay && !element.querySelector('.custom-cansPerCases')) {
                        const extraText = `<span class="custom-cansPerCases">(${numToDisplay} ${typeOfBottle})</span>`;
                        element.innerHTML = `<span class="custom-text">${numOfCases}<span class="plus-symbol">+</span> Cases</span> ${extraText}`;
                    } else {
                        element.innerHTML = `${element.innerText} <span class="custom-text">+</span>`;
                    }
                } else {
                    element.innerHTML = `${element.innerText} <span class="custom-text">+</span>`;
                }
            }

            if (element.innerText.includes('SAVE')) {
                element.classList.add('text-white');
            }
        });
    });

    init();
}

function checkIfBottleOrSlim() {
    const title = document.querySelector('.product__title');

    if (!title) return;

    let type;

    if (title.innerText.includes('BottleCan™')) {
        type = 'BottleCan™';
    } else if (title.innerText.includes('SlimCan')) {
        type = 'SlimCan';
    }

    return type;
}

function getNumberOfCans() {
    const text = document.querySelectorAll('.product__text');

    if (!text) return;

    const hasNum = /\d/;
    let splitText;
    
    for (const element of text) {
        if (hasNum.test(element.innerText)) {
            splitText = element.innerText.split('x');
        } else {
            continue;
        }
    }

    return splitText[0].trim();
}

function wrapNutritionTable() {
    const table = document.querySelector('.diet');

    if (!table) return;

    const leftEl = table.querySelectorAll('.diet-left');

    leftEl.forEach(element => {
        const elements = wrapPair(element, element.nextElementSibling);
        appendElement(table, elements, { 'class': 'diet-row'});
    });
}

function wrapPair(element, element2) {
    const wrapper = document.createElement('div');
    wrapper.append(element, element2);

    return wrapper;
}

function appendElement(parent, element, attribute = {}) {
    parent.insertAdjacentElement('beforeend', element);

    if (Object.keys(attribute).length) {
        for (const [key, value] of Object.entries(attribute)) {
            element.setAttribute(key, value);
        }
    }
}

function checkRatingScript() {
    const container = document.querySelector('.review-wrapper');
    
    if (!container) return;

    setTimeout(() => {
        const reviewWidget = container.querySelector('.ruk_rating_snippet');
        const prodContainer = document.querySelector('.product-info-simple');
        
        if (reviewWidget.innerHTML === "") {
            container.remove();
            prodContainer.classList.add('single');
        } else if (!document.querySelector('.product__text')) {
            prodContainer.classList.add('notext');
        }
    }, 250);
}

function createReviewClick() {
    const element = document.querySelector('#write-review');
    const reviewTab = document.querySelector('.reviews_tab');

    if (!element || !reviewTab) {
        element.remove();
        return;
    }

    element.addEventListener('click', () => {
        const container = document.querySelector('#pills-tab');

        if (!reviewTab) return;

        container.querySelectorAll('.nav-link').forEach(element => {
            if (element.classList.contains('active')) element.classList.remove('active');
        })

        reviewTab.classList.add('active');

        const tabContent = document.querySelector('#pills-tabContent');

        if (tabContent) {
            const panes = tabContent.querySelectorAll('.tab-pane');
            
            panes.forEach(element => {
                if (element.classList.contains('active')) element.classList.remove('active');
                if (element.classList.contains('show')) element.classList.remove('show');
            });

            const reviewContent = tabContent.querySelector('#pills-tab3');
            reviewContent.classList.add('active');
            reviewContent.classList.add('show');
        }

        reviewTab.scrollIntoView({ "behavior": "smooth" });
    });
}

function adjustQuantity() {
    const selector = document.querySelector('.quantity');
    const productName = document.querySelector('#product-name');

    if (!selector && !productName) return;

    selector.addEventListener('change', async (event) => {
        const quantity = event.target.value ?? selector.querySelector('.quantity__input').value;
        const priceEl = document.querySelector('#product-base-price');

        if (!window.product) {
            const response = await fetch(window.Shopify.routes.root + `products/${productName.value}.js`);

            if (response.status === 404) {
                const product = {
                    "price": Number(priceEl.value)
                }

                window.product = product;
                callForPriceChecks(product, quantity);  
            } else {
                const data = await response.json();
                window.product = data;
                callForPriceChecks(data, quantity);  
            }
        } else {
            callForPriceChecks(window.product, quantity);
        }

        const elements = document.querySelectorAll('.css-u91va4');

        if (!elements) return;

        if (quantity >= 2 && quantity < 4) {
            elements[1].classList.remove('selected');
            elements[0].classList.add('selected');
        } else if (quantity >= 4) {
            elements[0].classList.remove('selected');
            elements[1].classList.add('selected');
        } else {
            elements[0].classList.remove('selected');
            elements[1].classList.remove('selected');
        }
    });
}

function getDelivery() {
    const selector = document.querySelector('.bsub-widget__plans-container');
    const productName = document.querySelector('#product-name');

    if (!selector && !productName) return;
    
    selector.addEventListener('change', async (e) => {
        const parent = e.target.closest('[data-saving]') ?? document.querySelector('.bsub-widget__plans-container input:checked').closest('[data-saving]');
        const saving = parent.dataset.saving;

        const quantity = document.querySelector('.quantity__input').value;

        if (!window.product) {
            const response = await fetch(window.Shopify.routes.root + `products/${productName.value}.js`);

            if (response.status === 404) {
                const product = {
                    "price": Number(priceEl.value)
                }

                window.product = product;

                doPriceChecks(product, quantity, saving);
            } else {
                const data = await response.json();
                window.product = data;
                doPriceChecks(data, quantity, saving);  
            }
        } else {
            doPriceChecks(window.product, quantity, saving);
        }
    });
}

function callForPriceChecks(product, quantity, saving = 0) {
    setTimeout(() => {
        const query = window.location.search;
        const urlParams = new URLSearchParams(query);

        if (urlParams.has('selling_plan')) {
            const checkedInput = document.querySelector('.bsub-widget__plans-container input:checked');

            if (checkedInput) {
                const parent = checkedInput.closest('[data-saving]');
                const save = parent.dataset.saving;
                saving = save;
            }
        }
    
        doPriceChecks(product, quantity, saving);
    }, 250)
}

async function doPriceChecks(product, quantity, saving) {
    // const priceConverted = product.compare_at_price ? product.compare_at_price / 100 : product.price / 100;
    const priceConverted = product.price / 100;
    let originalTotal = priceConverted;
    let total = priceConverted;

    // discounts
    let discountedPrice = 0;

    if (saving) {
        saving = saving.replaceAll('-', '');
        const savingConverted = saving / 100;
        discountedPrice = originalTotal - savingConverted;
    }

    const discounts = getDiscounts();

    if (quantity >= 2 && quantity < 4) {
        const percentageOff = discounts[0] / 100;

        if (saving) {
            const converted = saving / 100;
            let temp  = originalTotal - converted;
            discountedPrice = temp - (temp * percentageOff);
        } else {
            discountedPrice = originalTotal - (originalTotal * percentageOff);
        }
    } else if (quantity >= 4) {
        const percentageOff = discounts[1] / 100;

        if (saving) {
            const converted = saving / 100;
            let temp  = originalTotal - converted;
            discountedPrice = temp - (temp * percentageOff);
        } else {
            discountedPrice = originalTotal - (originalTotal * percentageOff);
        }
    }

    let minDigits = 0;

    const setMinDigits = (priceToCheck) => {
        if (Number.isInteger(priceToCheck)) {
            minDigits = 0;
        } else {
            minDigits = 2;
        }
    }

    if (discountedPrice > 0) {
        setMinDigits(discountedPrice);
    } else {
        setMinDigits(total);
    }

    const currencyElement = document.querySelector('#store-currency').value ?? 'GBP';
    const formatted = discountedPrice > 0 ? formatCurrency(currencyElement, minDigits, discountedPrice) : formatCurrency(currencyElement, minDigits, total);
    const priceElement = document.querySelector('.price__regular .price-item') ?? '';
    const priceSaleElement = document.querySelector('.price__sale .price-item--sale') ?? ''; // sometimes an extra price element exists on the page for sale products

    if (priceElement) priceElement.innerText = formatted;
    if (priceSaleElement) priceSaleElement.innerText = formatted;

    if (discountedPrice > 0) {
        const priceContainer = document.querySelector('.price__container');
        let beforeDiscountFormatted = total;

        if (Number.isInteger(total)) {
            beforeDiscountFormatted = formatCurrency(currencyElement, 0, total);
        } else {
            beforeDiscountFormatted = formatCurrency(currencyElement, 2, total);
        }

        const originalPriceContainer = document.querySelector('.price-item--original');

        if (originalPriceContainer) {
            originalPriceContainer.innerHTML = beforeDiscountFormatted;
        } else {
            let nonDiscount = `<span class="price-item price-item--original">${beforeDiscountFormatted}</span>`;
            priceContainer.insertAdjacentHTML('afterbegin', nonDiscount);
        }
    } else {
        if (document.querySelector('.price-item--original')) {
            document.querySelector('.price-item--original').remove();
        }
    }
}

// Grab discounts from the builder elements directly where possible, otherwise fall back to using codes from settings
function getDiscounts () {
    const discountString = window.settings?.codes;
    const discounts = [];
    const builderElements = document.querySelectorAll('.upez-product-volume-upsell fieldset.builder-block > div:last-child') ?? [];

    if (builderElements.length) {
        builderElements.forEach(el => {
            const text = el.querySelector('.builder-text');

            if (text) {
                const val = text.innerText;
                const strippedText = val.replace(/\D/g, '');
                discounts.push(parseInt(strippedText, 10));
            }
        })
    } else {
        if (discountString) {
            const split = discountString.split(',');
    
            if (split) {
                split.forEach(str => {
                    if (str.includes('OFF')) {
                        const splitDiscount = str.replace('OFF', '');
                        discounts.push(parseInt(splitDiscount, 10));
                    }
                });
            }
        }

        return discounts.sort((a, b) => a - b) ?? [];
    }

    return discounts;
}

// set the discounts to always say 15% and 20%...
function setDiscounts() {
    const builderElements = document.querySelectorAll('.upez-product-volume-upsell fieldset.builder-block > div:last-child') ?? [];

    if (builderElements.length) {
        builderElements.forEach((el, i) => {
            const text = el.querySelector('.builder-text');

            if (text) {
                if (i === 0) {
                    text.innerText = 'SAVE 15%';
                } else {
                    text.innerText = 'SAVE 20%';
                }
            }
        })
    }
}

function formatCurrency(currencyElement, minDigits, value) {
    const currencyFormatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currencyElement,
        maximumFractionDigits: minDigits
    });

    return currencyFormatter.format(value);
}

function handleBulkButtonsClick() {
    const elements = document.querySelectorAll('.bsub-widget__group');

    const query = window.location.search;
    const urlParams = new URLSearchParams(query);

    if (urlParams.has('selling_plan')) {
        elements[0].classList.remove('isActive');
        elements[1].classList.add('isActive');
    } else {
        elements[0].classList.add('isActive');
    }

    elements.forEach(element => {
        element.addEventListener('click', (e) => {
            elements.forEach(element => {
                element.classList.contains('isActive') ? element.classList.remove('isActive') : "";
            });

            if (element.classList.contains('subscription-buy')) {
                triggerCustomEvent('.bsub-widget__plans-container');
            } else {
                triggerCustomEvent('.quantity');
            }

            element.classList.add('isActive');
        });
    })
}

function triggerCustomEvent(keyword) {
    const selector = document.querySelector(keyword);

    if (selector) {
        const event = new Event('change');
        selector.dispatchEvent(event);
    }
}
